import { Flex, Button } from '@chakra-ui/react';
import { URLS } from '@lib';
import Link from 'next/link';
import { useSegment } from '@hooks/use-segment';
import React from 'react';
import { openPopupWidget } from 'react-calendly';

export function CtaCard(props: { title: string }): JSX.Element {
  const analytics = useSegment();

  return (
    <Flex
      flexDir={{ base: 'column', md: 'row' }}
      align="center"
      justify={{ base: 'center', md: 'center', xl: 'flex-start' }}
      w="full"
      gap={{ base: 4, md: 0 }}
      pos="relative"
      mt={8}
    >
      <Link
        legacyBehavior
        href={process.env.NEXT_PUBLIC_DASHBOARD_URL as string}
        passHref
      >
        <Button
          as="a"
          variant="base"
          w={{ base: '84vw', sm: 225 }}
          h={'48px'}
          fontSize="md"
          zIndex={100}
          onClick={() => {
            analytics.track(
              `${props.title}_Customization_Start Building Button Clicked`,
              { surface: 'Marketing', location: 'Home' }
            );
          }}
        >
          Start Building
        </Button>
      </Link>

      <Button
        w={{ base: '84vw', sm: 225 }}
        h={'48px'}
        variant="white"
        fontSize="md"
        onClick={() => {
          openPopupWidget({
            url: URLS.calendlyUrl
          });
          analytics.track('Marketing_Home_Schedule a Demo Button Clicked', {
            surface: 'Marketing',
            location: 'Home'
          });
        }}
        mx={{ base: 0, sm: 4 }}
        my={{ base: 4, sm: 0 }}
      >
        Schedule a Demo
      </Button>
    </Flex>
  );
}
